import React from 'react';
import Users from './dashboard/views/users/Users';
import Dashboard from './dashboard/views/dashboard/Dashboard';
import Category from './dashboard/views/category/Category';

import MenuProducts from './dashboard/views/products/Menu-Products';
import Messages from './dashboard/views/messages/Messages';
import Deals from './dashboard/views/deals/Deals';
import Orders from './dashboard/views/orders/Orders';
import EditProfile from './dashboard/views/profile/EditProfile';
import Reviews from './dashboard/views/profile/Reviews';
import Invoice from './dashboard/views/invoice/Invoice';
import Visitors from './dashboard/views/visitors/Visitors';
import Gallery from './dashboard/views/profile/Gallery';
import Followers from './dashboard/views/base/followers/Followers';
import Upgrade from './dashboard/views/upgrade/Upgrade';
import PreOrder from './dashboard/views/pre-orders/PreOrders';
import PreOrders from './dashboard/views/pre-orders/Pre-Order';
import PublicProfile from './dashboard/views/public-profile/PublicProfile';
import Contact from './components/Contact';



const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard/upgrade', exact: true,  name: 'Upgrade', component: Upgrade },
  { path: '/contact', exact: true,  name: 'Contact', component: Contact },
  { path: '/dashboard/analytics/pre-order', exact: true,  name: 'PreOrder', component: PreOrder },
  { path: '/dashboard/pre-order', exact: true,  name: 'PreOrders', component: PreOrders },
  { path: '/dashboard/analytics/visitors', exact: true,  name: 'Visitors', component: Visitors },
  { path: '/dashboard/users', exact: true,  name: 'Users', component: Users },
  { path: '/dashboard/publicProfile', exact: true,  name: 'PublicProfile', component: PublicProfile },
  { path: '/dashboard/invoice', exact: true,  name: 'Invoice', component: Invoice },
  { path: '/dashboard/category', exact: true,  name: 'Category', component: Category },
  { path: '/dashboard/analytics/followers', exact: true,  name: 'Followers', component: Followers },
  { path: '/dashboard/products', exact: true,  name: 'Products', component: MenuProducts },
  { path: '/dashboard/reviews', exact: true,  name: 'Reviews', component: Reviews },
  { path: '/dashboard/gallery', exact: true,  name: 'Gallery', component: Gallery },
  { path: '/dashboard/messages', exact: true, name: 'Messages', component: Messages },
  { path: '/dashboard/orders', exact: true,  name: 'Orders', component: Orders },
  { path: '/dashboard/menu-products', exact: true,  name: 'MenuProducts', component: MenuProducts },
  { path: '/dashboard/deals', exact: true,  name: 'Deals', component: Deals },
  { path: '/dashboard/edit', exact: true,  name: 'Deals', component: EditProfile },
  { path: '/dashboard', exact: true, name: 'Dashboard', component: Dashboard },
];

export default routes;
